import { GlobalAxios } from "../axios/axios-config";

const INVOICE_SERVICE_AGY_RESTART_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/InvoiceServiceAgy/RestartInvoiceServiceAgy";
const INVOICE_SERVICE_AGY_CONSIST_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/InvoiceServiceAgy/ConsistInvoiceServiceAgy";

export const restartInvoiceServiceAgyRetries = ({
  identifier,
  identifierList,
}: {
  identifier?: number;
  identifierList?: number[];
}) => {
  return GlobalAxios.put(INVOICE_SERVICE_AGY_RESTART_ROUTE, {
    identifier,
    identifierList,
    ExtensionCode: "72",
  });
};

export const consistInvoiceServiceAgyRetries = ({
  identifier,
  identifierList,
}: {
  identifier?: number;
  identifierList?: number[];
}) => {
  return GlobalAxios.put(INVOICE_SERVICE_AGY_CONSIST_ROUTE, {
    identifier,
    identifierList,
    ExtensionCode: "72",
  });
};

